import { createFileRoute } from '@tanstack/react-router'
import { MailLinkFallback } from './-components/mail-link-fallback'
import {
	buildMailLinkSeo,
	mailLinkSearchSchema
} from './-lib/mail-link-fallback'

export const Route = createFileRoute('/(public)/magic-link')({
	ssr: true,
	validateSearch: mailLinkSearchSchema,
	head: ({ match }) =>
		buildMailLinkSeo({
			appLanguage: match.context.appLanguage,
			flow: 'magic_link',
			path: '/magic-link'
		}),
	component: MagicLinkFallback
})

function MagicLinkFallback() {
	const { appLanguage } = Route.useRouteContext()
	const { token } = Route.useSearch()
	return (
		<MailLinkFallback
			appLanguage={appLanguage}
			flow='magic_link'
			proof={token}
		/>
	)
}
